import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=a935a4e6&scoped=true&"
import script from "./FaqItem.vue?vue&type=script&lang=js&"
export * from "./FaqItem.vue?vue&type=script&lang=js&"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=a935a4e6&lang=scss&scoped=true&"
import style1 from "./FaqItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a935a4e6",
  null
  
)

export default component.exports